import vision from '../assets/images/vision.png'
import mission from '../assets/images/mission.png'
import values from '../assets/images/values.png'

function ShowContent(){
    return(
        <section className='container-fluid px-3 px-md-5 statement-section'>
            <div className='row statement-content justify-content-center'>
                <div className='col-md-4 col-12 mb-4 mb-md-0'>
                    <div className='statement-card-mission h-100'>
                        <div className="d-flex align-items-center mb-3">
                            <img 
                                src={mission} 
                                alt='mission icon' 
                                className='statement-image me-3' 
                            />
                            <h3 className='text1 mb-0'>
                                Mission Statement
                            </h3>
                        </div>
                        <p className='text2 statement mb-0'>
                            To foster the holistic development of youth by providing comprehensive educational, health, and empowerment initiatives, ensuring an inclusive and empowered future for all.
                        </p>
                        <div className="mt-auto pt-3">
                            <div className="d-flex align-items-center text-primary">
                                <i className="bi bi-target me-2"></i>
                                <small className="fw-semibold">Our Purpose</small>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className='col-md-4 col-12 mb-4 mb-md-0'>
                    <div className='statement-card-vision h-100'>
                        <div className="d-flex align-items-center mb-3">
                            <img 
                                src={vision} 
                                alt='vision icon' 
                                className='statement-image me-3' 
                            />
                            <h3 className='text1 mb-0'>
                                Vision Statement
                            </h3>
                        </div>
                        <p className='text2 statement mb-0'>
                            Inspiring positive change and unity among civil society organizations through collaborative efforts and shared values.
                        </p>
                        <div className="mt-auto pt-3">
                            <div className="d-flex align-items-center text-primary">
                                <i className="bi bi-eye me-2"></i>
                                <small className="fw-semibold">Our Future</small>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className='col-md-4 col-12'>
                    <div className='statement-card-values h-100'>
                        <div className="d-flex align-items-center mb-3">
                            <img 
                                src={values} 
                                alt='values icon' 
                                className='statement-image me-3' 
                            />
                            <h3 className='text1 mb-0'>
                                Our Values
                            </h3>
                        </div>
                        <div className='text2 statement mb-0'>
                            <div className="d-flex flex-wrap gap-2">
                                <span className="badge bg-primary-light text-primary px-3 py-2 rounded-pill">Inclusivity</span>
                                <span className="badge bg-primary-light text-primary px-3 py-2 rounded-pill">Integrity</span>
                                <span className="badge bg-primary-light text-primary px-3 py-2 rounded-pill">Respect</span>
                                <span className="badge bg-primary-light text-primary px-3 py-2 rounded-pill">Innovation</span>
                                <span className="badge bg-primary-light text-primary px-3 py-2 rounded-pill">Collaboration</span>
                            </div>
                        </div>
                        <div className="mt-auto pt-3">
                            <div className="d-flex align-items-center text-primary">
                                <i className="bi bi-heart me-2"></i>
                                <small className="fw-semibold">Our Principles</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ShowContent;